import React, { useState, forwardRef } from 'react';
import {inputStyles} from "../utils/General";

const Input = forwardRef(({
                              min,
                              max,
                              maxLength,
                              minLength,
                              name,
                              type = 'text',
                              value,
                              onChange,
                              placeholder = '',
                              style = {},
                              className = '',
                              disabled = false,
                              isTextarea,
                              resize,
                              onBlur = () => {},
                              defaultValue,
                          }, ref) => {
    const [isFocused, setIsFocused] = useState(false);

    const handleBlur = () => {
        setIsFocused(false);
    };

    return isTextarea ? (
        <textarea
            ref={ref}
            defaultValue={defaultValue}
            maxLength={maxLength}
            minLength={minLength}
            name={name}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            style={{
                ...inputStyles.input,
                ...style,
                ...(isFocused ? inputStyles.inputFocus : {}),
                cursor: disabled ? 'not-allowed' : 'text',
                resize: resize
            }}
            className={'standard-input' + ' ' + className}
            onFocus={() => setIsFocused(true)}
            onBlur={(e) => {
                handleBlur();
                if (typeof onBlur === 'function') {
                    onBlur(e);
                }
            }}
            disabled={disabled}
        />
    ) : (
        <input
            ref={ref}
            defaultValue={defaultValue}
            min={min}
            max={max}
            maxLength={maxLength}
            minLength={minLength}
            name={name}
            type={type}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            style={{
                ...inputStyles.input,
                ...style,
                ...(isFocused ? inputStyles.inputFocus : {}),
                cursor: disabled ? 'not-allowed' : 'text',
            }}
            className={'standard-input' + ' ' + className}
            onFocus={() => setIsFocused(true)}
            onBlur={(e) => {
                handleBlur();
                if (typeof onBlur === 'function') {
                    onBlur(e);
                }
            }}
            disabled={disabled}
        />
    );
});

export default Input;



// WEBPACK FOOTER //
// ./src/components-new/Input.jsx